
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, Mail, Share2, MessageCircle } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface ShareButtonsUIProps {
  onDownload: () => void;
  onEmailShare: () => void;
  onWhatsAppShare: () => void;
  onTelegramShare: () => void;
  onSMSShare: () => void;
}

export const ShareButtonsUI: React.FC<ShareButtonsUIProps> = ({
  onDownload,
  onEmailShare,
  onWhatsAppShare,
  onTelegramShare,
  onSMSShare
}) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`grid ${isMobile ? 'grid-cols-2' : 'grid-cols-3'} gap-2`}>
      <Button 
        variant="outline" 
        className="flex items-center justify-center gap-2"
        onClick={onDownload}
      >
        <Download className="h-4 w-4" />
        {!isMobile && "Download"}
      </Button>
      
      <Button 
        variant="outline" 
        className="flex items-center justify-center gap-2"
        onClick={onEmailShare}
      >
        <Mail className="h-4 w-4" />
        {!isMobile && "Email"}
      </Button>
      
      <Button 
        variant="outline" 
        className="flex items-center justify-center gap-2"
        onClick={onWhatsAppShare}
      >
        <img src="https://cdn-icons-png.flaticon.com/512/124/124034.png" className="h-4 w-4" alt="WhatsApp" />
        {!isMobile && "WhatsApp"}
      </Button>
      
      <Button 
        variant="outline" 
        className="flex items-center justify-center gap-2"
        onClick={onTelegramShare}
      >
        <img src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png" className="h-4 w-4" alt="Telegram" />
        {!isMobile && "Telegram"}
      </Button>
      
      <Button 
        variant="outline" 
        className={`flex items-center justify-center gap-2 ${isMobile ? 'col-span-2' : 'col-span-1'}`}
        onClick={onSMSShare}
      >
        <MessageCircle className="h-4 w-4" />
        {!isMobile && "Messages"}
      </Button>
    </div>
  );
};

export default ShareButtonsUI;
